import { autoinject, Container } from "aurelia-framework";

@autoinject()
export class DynamicImportService {

    getInstance<T = any>(promise: Promise<any>, container: Container = Container.instance): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            promise.then(handler => {
                const key = Object.keys(handler).filter(key => key != "__esModule")[0];
                const instance = container.get(handler[key]);
                resolve(instance);
            }).catch(e => {
                reject(e);
            });
        });
    }
}
